import React from "react";
import { Link } from "react-router-dom";
import { categories, stats } from "./homeData";

export function CategoriesSection() {
  return (
          <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
            <div className="flex items-end justify-between mb-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-widest text-[#D4AF37]">Browse by topic</span>
                <h2 className="mt-2 text-3xl lg:text-4xl font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }}>What do you need help with?</h2>
              </div>
              <Link to="/lawyers" className="hidden md:inline text-sm font-bold text-[#0A2540] hover:text-[#D4AF37]">View all →</Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {categories.map((c) => (
                <Link
                  to={`/lawyers?spec=${encodeURIComponent(c.spec)}`}
                  key={c.title}
                  data-testid={`category-${c.title.toLowerCase()}`}
                  className="group bg-white border border-slate-200 rounded-2xl p-5 hover:shadow-xl hover:-translate-y-1 transition-all"
                >
                  <div className="h-11 w-11 rounded-xl grid place-items-center" style={{ background: `${c.color}20`, color: c.color }}>
                    <c.icon size={22} />
                  </div>
                  <h3 className="mt-4 text-lg font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }}>{c.title}</h3>
                  <p className="text-xs text-slate-500 mt-0.5">{c.sub}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-[#D4AF37] group-hover:gap-2 transition-all">{c.cta} →</span>
                </Link>
              ))}
            </div>
          </section>
  );
}

export function StatsSection() {
  return (
          <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-14">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
              {stats.map((s) => (
                <div key={s.l} className="text-center" data-testid={`stat-${s.v.replace(/\W/g, "")}`}>
                  <p className="text-2xl md:text-3xl font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }}>{s.v}</p>
                  <p className="text-[11px] md:text-xs font-semibold text-slate-500 mt-1">{s.l}</p>
                </div>
              ))}
            </div>
          </section>
  );
}
